import { useState, useEffect } from 'react';
import { useEscapeClose } from '../../../utils/SamuiUtils';
import { useModalKeyboardNavigation, scrollToRow, getRowStyle, getKeyboardInstructions } from '../../../utils/ModalKeyboardNavigation';

const CarModal = ({
    showCarModal,
    handleCarClose,
    carDataList,
    onRowSelectCar
}) => {
    // สถานะการค้นหา
    const [searchTerm, setSearchTerm] = useState('');
    const [filteredCarDataList, setFilteredCarDataList] = useState(carDataList);
    const [selectedRowIndex, setSelectedRowIndex] = useState(0); // เพิ่ม state สำหรับเลือกแถว

    useEscapeClose(showCarModal, handleCarClose);
    
    // เพิ่ม keyboard navigation
    useModalKeyboardNavigation(
        showCarModal,
        filteredCarDataList,
        selectedRowIndex,
        setSelectedRowIndex,
        onRowSelectCar,
        handleCarClose
    );

    useEffect(() => {
        setFilteredCarDataList(
            carDataList.filter(ar =>
                ar.Car_No.toLowerCase().includes(searchTerm.toLowerCase()) ||
                ar.Car_Name.toLowerCase().includes(searchTerm.toLowerCase())
            )
        );
        setSelectedRowIndex(0); // รีเซ็ตการเลือกแถวเมื่อข้อมูลเปลี่ยน
    }, [searchTerm]);

    useEffect(() => {
        if (showCarModal) {
            setSearchTerm('');
            setSelectedRowIndex(0); // รีเซ็ตการเลือกแถวเมื่อเปิด modal
        }
    }, [showCarModal]);

    return (
        <>
            <div className={`modal ${showCarModal ? 'show' : ''}`} style={{ display: showCarModal ? 'block' : 'none' }} tabIndex="-1" role="dialog">
                <div className="modal-dialog modal-lg" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">รายชื่อรถ</h5>
                            <button type="button" className="close" onClick={handleCarClose}>
                                <span>&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="table-responsive" style={{ maxHeight: '650px', overflowY: 'auto' }}>
                                <table className="table table-striped table-hover">
                                    <thead className="thead-dark">
                                        <tr>
                                            <th className="text-center" style={{ width: '139px' }}>ทะเบียนรถ</th>
                                            <th className="text-center" style={{ width: '620px' }}>ชื่อรถ</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {filteredCarDataList && filteredCarDataList.length > 0 ? (
                                            filteredCarDataList.map((car, index) => (
                                                <tr
                                                    key={car.Car_id || index + 1}
                                                    onClick={() => onRowSelectCar(car)}
                                                    style={{ cursor: 'pointer' }}>
                                                    <td className="text-center">{car.Car_No}</td>
                                                    <td style={{ textAlign: 'left' }}>{car.Car_Name}</td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan="10">
                                                    <center>
                                                        <h5>ไม่พบข้อมูล</h5>
                                                    </center>
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button className="btn btn-danger" onClick={handleCarClose}>
                                ปิด
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            {/* Overlay */}
            {showCarModal && <div className="modal-backdrop fade show"></div>}
        </>
    );
};

export default CarModal;
